<template>
  <Spinner :loading="Loading" />
  <div class="row background-map">
    <div class="col-md-12">
      <div class="container">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div class="logincard">
              <h1 class="pt-0"><img src="@/assets/imgs/SPVI.png" fluid class="logospv" /></h1>
              <hr class="border-vert-SPVI" />
              <Form @submit="handleLogin" :validation-schema="schema">
                <div class="row marginBottom10px">
                  <div class="col-md-4 text-right align-self-center"><label for="username" class="mb-0 text-muted font-weight-bold">Login :</label></div>
                  <div class="col-md-6">
                    <Field name="username" type="text" class="form-control" />
                    <ErrorMessage name="username" class="error-feedback" />
                  </div>
                </div>
                <div class="row marginBottom10px mt-3">
                  <div class="col-md-4 text-right align-self-center"><label for="password" class="mb-0 text-muted font-weight-bold">Mot de passe :</label></div>
                  <div class="col-md-6">
                    <Field name="password" type="password" class="form-control" />
                    <ErrorMessage name="password" class="error-feedback" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 offset-md-4 mt-2"><button class="btn btn-green" :disabled="loading">
                      <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                      <span>SE CONNECTER</span>
                    </button>
                  </div>
                </div>
                <div class="form-group errorMessage">
                  <div v-if="message" class="alert alert-danger" role="alert">
                    {{ message }}
                  </div>
                </div>
              </Form>

              <!-- <div class="row">
                <div class="col-md-12 text-center">
                  <RouterLink to="/mot-de-passe-oublie">Mot de passe oublié ?</RouterLink>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <Footer />
</template>
  
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import Footer from "@/components/Public/Footer.vue";
import Header from "@/components/Public/Header.vue";
import Spinner from "@/components/Spinner.vue";
import * as yup from "yup";

export default {
  name: "Login",
  components: {
    Footer,
    Form,
    Field,
    ErrorMessage,
    Spinner
  },
  data() {
    const schema = yup.object().shape({
      username: yup.string().required("Le username est obligatoire."),
      password: yup.string().required("Le mot de passe est obligatoire."),
    });

    return {
      loading: false,
      message: "",
      schema,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      if (this.$store.state.auth && this.$store.state.auth.user && this.$store.state.auth.user.role == "admin") {
        this.$router.push("/gestionSaisies");
      } else {

        this.$router.push("/home");
      }
    }
  },
  methods: {
    handleLogin(user) {
      this.loading = true;
      this.$store.dispatch("auth/login", user).then(
        () => {
          if(this.$store.state.auth.user.role == "admin"){
            this.$router.push("/gestionSaisies");
          }else{
            this.$router.push("/home");
          }
        },
        (error) => {
          this.loading = false;
          this.message = error.response.data;
          // (error.response &&
          //   error.response.data &&
          //   error.response.data.message) ||
          // error.message ||
          // error.toString();
        }
      );
    },
  },
};
</script>
  
<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_public.scss";

</style>